enum EnumErrorType {
    InvalidParamError = 0,
    NoPermissionError = 1,
    ParserError,
    HttpInvalidTokenError,
}

export default EnumErrorType
